import {Bar} from "react-chartjs-2";
import {CategoryScale, Chart as ChartJS, ChartOptions} from "chart.js/auto";
import annotationPlugin from "chartjs-plugin-annotation";
import {StreakChartDataType} from "..";
ChartJS.register(CategoryScale);
ChartJS.register(annotationPlugin);

const offBar = "#D2D5E2";
const onBar = "#A4C286";

interface StreakChartUIProps {
  chartData?: StreakChartDataType[];
  goal: number;
}
export default function StreakChartUI({chartData, goal}: StreakChartUIProps) {
  const options: ChartOptions<"bar"> = {
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          color: "#5A5A5A",
        },
      },
      y: {
        grid: {
          display: true,
          color: "#F3F2F7",
        },
        ticks: {
          display: true,
          color: "#5A5A5A80",
        },
        border: {
          width: 10,
          color: "transparent",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      annotation: {
        annotations: {
          line1: {
            drawTime: "afterDraw",
            type: "line",
            yMin: goal,
            yMax: goal,
            borderColor: "rgb(255, 99, 132)",
            borderWidth: 1,
            borderDash: [5, 5],
          },
        },
      },
      tooltip: {},
    },
  };
  const weekMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const data = {
    labels:
      chartData?.map(data => weekMap[new Date(data.date).getDay()]) ||
      weekMap.slice(1, -1),
    datasets: [
      {
        label: "Streak",
        data: chartData?.map(data => data.score) || Array(7).fill(0),
        backgroundColor: [
          offBar,
          offBar,
          offBar,
          offBar,
          offBar,
          offBar,
          onBar,
        ],
        barThickness: 20,
        borderRadius: 4,
        borderSkipped: false,
      },
    ],
  };
  return <Bar data={data} options={options} />;
}
